import { _metrics } from 'src/app/shared/constants/sonar';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalLoadingComponent } from '../components/loads/modal-loading/modal-loading.component';
import { catchError, map } from 'rxjs/operators';
import { forkJoin, Observable, of } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

export function formatTimeStamp(data) {
    const dataOriginal = new Date(data);
    dataOriginal.setUTCHours(dataOriginal.getUTCHours() + 3);
    return new Date(dataOriginal).getTime() / 1000;
}

export function sortByRegExp(a, b) {
    const re0: RegExp =
    /(^develop$)|(^release$)|(^staging$)|(^master$)|(^main$)/gm;

    const re1: RegExp = /(^feature$)|(^feat$)/gm;

    let valueA = 2
    if (a.match(re0)) valueA = 0
    else if (a.match(re1)) valueA = 1 

    let valueB = 2;
    if (b.match(re0)) valueB = 0;
    else if (b.match(re1)) valueB = 1; 
    
  return valueA - valueB;
};

  export function modalLoading(dialog: MatDialog): MatDialogRef<ModalLoadingComponent> {
    return dialog.open(ModalLoadingComponent, {
      autoFocus: true,
      disableClose: true,
      width: '400px',
      data: {
        disableClose: true,
        title: 'Carregando',
        text: 'Por favor espere alguns momentos',
      },
      panelClass: 'loading-modal',
    });
  }


export function generateProjectsBadges(
  http: HttpClient,
  apiUrl: string,
  currentProject: string,
  projectLinks: Record<string, string>,
  metrics: Array<unknown>,
  sanitizer: DomSanitizer
): Observable<Array<{ name: string; svg: string; dataUrl: SafeResourceUrl; link: string }>> {
  const metricTranslations: Record<string, string> = {
    'coverage': 'Cobertura',
    'duplicated_lines_density': 'Densidade de linhas duplicadas',
    'ncloc': 'Linhas de código',
    'alert_status': 'Status do Quality Gate',
    'security_hotspots': 'Pontos de risco de segurança',
    'bugs': 'Bugs',
    'code_smells': 'Code Smells',
    'vulnerabilities': 'Vulnerabilidades',
    'sqale_rating': 'Nota de Manutenibilidade',
    'reliability_rating': 'Nota de Confiabilidade',
    'security_rating': 'Nota de Segurança',
    'sqale_index': 'Dívida Técnica',
    'software_quality_reliability_issues': 'Problemas de Confiabilidade',
    'software_quality_maintainability_issues': 'Problemas de Manutenibilidade',
    'software_quality_security_issues': 'Problemas de Segurança',
    'software_quality_maintainability_rating': 'Classificação de Manutenibilidade',
    'software_quality_reliability_rating': 'Classificação de Confiabilidade',
    'software_quality_security_rating': 'Classificação de Segurança',
    'software_quality_maintainability_remediation_effort': 'Esforço de Remediação da Manutenibilidade'
  };

  const requests: Observable<{ name: string; svg: string; dataUrl: SafeResourceUrl; link: string } | null>[] = metrics.map((metric: string) => {
    const url = `${apiUrl}/projects/sonar/badge?project=${currentProject}&metric=${metric}`;

    return http.get(url, { responseType: 'text' }).pipe(
      map(svg => {
        const encodedSvg = encodeURIComponent(svg);
        const dataUrl = `data:image/svg+xml;utf8,${encodedSvg}`;
        const safeDataUrl = sanitizer.bypassSecurityTrustResourceUrl(dataUrl);

        return {
          name: metricTranslations[metric] || metric,
          svg,
          dataUrl: safeDataUrl,
          link: projectLinks[currentProject]
        };
      }),
      catchError(() => of(null)) // retorna null em caso de erro
    );
  });

  return forkJoin(requests).pipe(
    map(results => results.filter(r => r !== null) as Array<{ name: string; svg: string; dataUrl: SafeResourceUrl; link: string }>)
  );
}
